<template>
  <div class="article-detail">
    <h3>
      一、在推精灵平台进行任何广告活动，都需要先注册成为联盟会员，注册具体步骤如下：
    </h3>
    <p>注册激活账户-->获取代码/投放广告-->赚取佣金</p>
    <p>
      Step1: 注册推精灵账户，注册时微信关注推精灵公众号授权登录即为您的账号。
    </p>
    <p>注册途径：</p>
    <p>
      直接通过官网首页
      <a href="https://saas.tuielf.com/supplier" target="_blank">
        https://saas.tuielf.com/supplier
      </a>
      ，微信扫一扫页面中的二维码关注公众号后即可完成注册。
    </p>

    <p>
      <img
        v-viewer
        style="width: 600px"
        src="../../assets/supplier1.png"
        alt=""
      />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
h3 {
  font-size: 16px;
  font-weight: 700;
}
p {
  margin: 10px 0;
  font-size: 16px;
}

a {
  font-size: 16px;
  color: #4080ff;

  &:hover {
    text-decoration: underline;
  }
}

img {
  max-width: 100%;
}
</style>
